import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

let scrollBlockCount = 0;

// Hook to prevent scrolling
export const usePreventScrolling = () => {
  useEffect(() => {
    scrollBlockCount += 1;

    const body = document.body;
    const hasScrollbar = body.scrollHeight > window.innerHeight;

    if (scrollBlockCount === 1) {
      body.style.overflow = 'hidden';

      // Apply paddingRight only if the page has a visible scrollbar
      if (hasScrollbar) {
        body.style.paddingRight = `${'17px'}`;
      }
    }

    return () => {
      scrollBlockCount -= 1;

      if (scrollBlockCount === 0) {
        body.style.overflow = 'auto';
        body.style.paddingRight = '0';
      }
    };
  }, []);
};

// Hook to scroll to the top on route change
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');

      const scrollToHashWithOffset = () => {
        const target = document.getElementById(id);
        if (!target) return false;

        const navbar = document.getElementById('site-navbar');
        const navbarHeight = navbar ? navbar.getBoundingClientRect().height : 0;
        const navbarMarginTop = navbar
          ? parseFloat(window.getComputedStyle(navbar).marginTop || '0')
          : 0;
        const offset = navbarHeight + navbarMarginTop + 12;
        const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: 'smooth',
        });

        return true;
      };

      if (!scrollToHashWithOffset()) {
        // Retry a few times in case the section is rendered slightly later.
        let tries = 0;
        const interval = window.setInterval(() => {
          tries += 1;
          const found = scrollToHashWithOffset();
          if (found || tries >= 12) {
            window.clearInterval(interval);
          }
        }, 70);

        return () => window.clearInterval(interval);
      }

      return;
    }

    window.scrollTo(0, 0); // Scroll to the top on route change
  }, [pathname, hash]);

  return null; // This component doesn't render anything
};
